import {Inject, Singleton} from '@denishussar/html5-game-engine';
import * as amplitude from '@amplitude/analytics-browser';
import { GameEvent } from '../../Constants/GameEvent';
import {Route} from "../../Utils/Helpers";
import * as packageMeta from "../../../../package.json";
import {GameModel} from "../../Models/GameModel";

const BWA_REG_TIME = '__bwa__reg_time__';
const BWA_LAST_ACTIVE_TIME = '__bwa__last_active_time__';
const BWA_DATE_COUNTER = '__bwa__date_counter__';

const version = packageMeta.version;

@Singleton
export class AmplitudeAnalyticsService {
    private _lifeDay: number = 0;
    private _identify: amplitude.Identify;
    private _startSessionTime = Date.now();

    private _referrerSite: string;

    constructor(
        @Inject private gameModel: GameModel
    ) {
        if (window['__DISABLE_ANALYTICS__']) return;
        if (location.hostname === 'localhost') return;
        if (location.hostname === '0.0.0.0') return;
        amplitude.init('4b1fe83101575b4d260dea04436a8693');

        this._identify = new amplitude.Identify();

        let counter = 0;
        let counterDepth = 15;

        let currObj = window;
        try {
            while (currObj?.parent?.document?.referrer) {
                //@ts-ignore
                currObj = currObj.parent;
                counter++;

                if (counter >= counterDepth) {
                    break;
                }
            }
        } catch (e) {}

        this._referrerSite = currObj.document.referrer;

        this.logLifetime();
        this.logPlatformType();
        this.logVersion();
        this.logIsDeveloper();
    }

    sendEvent(eventName: GameEvent, eventParams: object = {}) {
        if (window['__DISABLE_ANALYTICS__']) return;
        if (location.hostname === 'localhost') return;
        if (location.hostname === '0.0.0.0') return;

        eventParams['life_day'] = this._lifeDay;
        eventParams['version'] = version;
        eventParams['platform'] = window['current_social'] ?? 'testing';
        eventParams['isDeveloper'] = !!Route.searchParam('dev');

        eventParams['lifetimeSession'] = Math.floor((Date.now() - this._startSessionTime) / 1000 / 60);

        this.updateUserData();

        amplitude.logEvent(eventName, eventParams);
    }

    sendEventPage(pageName: string, eventParams: object = {}) {
        // TODO:
    }

    private updateUserData(): void {
        const identify = new amplitude.Identify();
        identify.set("coins", this.gameModel.userBalanceCoins);
        identify.set("boosterLine", this.gameModel.userBalanceBoosterLine);
        identify.set("boosterYarn", this.gameModel.userBalanceBoosterBrush);
        identify.set("boosterBucket", this.gameModel.userBalanceBoosterBucket);
        identify.set("referrer_site", this._referrerSite);

        amplitude.identify(identify);
    }

    private logIsDeveloper(): void {
        const identify = this._identify.set(
            'isDeveloper',
            !!Route.searchParam('dev')
        );
        amplitude.identify(identify);
    }

    private logPlatformType(): void {
        const identify = this._identify.setOnce(
            'platform',
            window['current_social'] ?? 'testing'
        );
        amplitude.identify(identify);
    }

    private logVersion(): void {
        let identify: amplitude.Identify;

        identify = this._identify.setOnce(
            'initVersion',
            version
        );
        amplitude.identify(identify);

        identify = this._identify.set(
            'currentVersion',
            version
        );
        amplitude.identify(identify);
    }

    private logLifetime(): void {
        const registrationTime = localStorage.getItem(BWA_REG_TIME);
        const lastActiveTime = localStorage.getItem(BWA_LAST_ACTIVE_TIME);
        const dayCounter = localStorage.getItem(BWA_DATE_COUNTER);

        let identify: amplitude.Identify;

        // Информация об регистрации
        if (!registrationTime) {
            localStorage.setItem(BWA_REG_TIME, String(Date.now()));

            identify = this._identify.setOnce(
                'registration',
                Date.now()
            );
            amplitude.identify(identify);

            identify = this._identify.setOnce(
                'registration_human',
                new Date().toUTCString()
            );
            amplitude.identify(identify);
        }

        // Если регистрация
        if (!lastActiveTime) {
            const currentDay = 0;
            localStorage.setItem(BWA_LAST_ACTIVE_TIME, String(Date.now()));
            localStorage.setItem(BWA_DATE_COUNTER, String(currentDay));
            this._lifeDay = currentDay;

            identify = this._identify.set('life_day', currentDay);
            amplitude.identify(identify);
        } else { // Если уже заходили и имеется информация
            const unixFormat = Number(lastActiveTime);
            const date = new Date(unixFormat);
            const lastDay = date.getDate();
            const currentDay = new Date().getDate();

            // Если новый день, то прибавляем счетчик
            if (lastDay !== currentDay) {
                const currentDay = Number(dayCounter) + 1;
                localStorage.setItem(BWA_LAST_ACTIVE_TIME, String(Date.now()));
                localStorage.setItem(BWA_DATE_COUNTER, String(currentDay));
                this._lifeDay = currentDay;

                identify = this._identify.set('life_day', currentDay);
                amplitude.identify(identify);
            } else {// Если тот же самый день
                this._lifeDay = Number(dayCounter);
            }
        }
    }
}
